<template>
  <div class="news">
    <HeaderNav :current="current" :titleMsg='titleMsg'></HeaderNav>
    <div class="set-height">
      <div class="news-content w1200">
        <div class="text">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>证书查询</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="layout-center">
          <div class="layout-left">
            <h2 class="clum">
              <i class="icon">证书查询</i>
            </h2>
            <div class="person-bar">
              <span>个人证书</span>
              <!-- <el-select v-model="value" placeholder="选择项目" @change="((val)=>{selectOp(val)})">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.projectName"
                  :value="item.id"
                  >
                </el-option>
              </el-select> -->
            </div>
          </div>

          <div class="certificate-nav">
            <h2 class="person-text-title"><span>个人证书查询</span></h2>
            <div class="check-nav">
              <!-- <el-input
                placeholder="请输入需要查询证书人姓名"
                v-model="name"
                clearable>
              </el-input> -->
              <el-input
                placeholder="请输入需要查询证书编号"
                v-model="certificateNumStr"
                clearable>
              </el-input>
              <div class="submit-btn">
                <el-button type="primary" icon="el-icon-search"  @click="getPersonCertificatr()">搜索</el-button>
              </div>
              <div class="code_img">
                <img src="static/images/qr_code.png" alt="">
                <span>移动设备查询，请扫描上方二维码</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="fixd">
      <CopyRight></CopyRight>
    </div>
  </div>
</template>

<script>
import { findUserCertDetail, queryAllProject } from '@/api/association'
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
export default {
  name: 'PersonalCertificate',
  components: {
    HeaderNav,
    CopyRight
  },
  data () {
    return {
      current: 3,
      input: '',
      name: '',
      value: '',
      options: [],
      projectId: '',
      certificateNumStr: '',
      titleMsg: '证书查询'
    }
  },
  methods: {
    // 查询协会下所有项目
    getQueryAllProject () {
      this.options = []
      queryAllProject({ assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          this.options = res.data.data
          console.log(res.data)
        }
      })
    },
    selectOp (item, event) {
      console.log(item)
      this.projectId = item
    },
    getPersonCertificatr () {
      // if (this.projectId === '') {
      //   this.$message.error('请选择项目')
      //   return false
      // }
      if (this.certificateNumStr === '') {
        this.$message.error('请输入需要查询的证书编号')
        return false
      }
      // findUserCertDetailByProject
      findUserCertDetail({ certNo: this.certificateNumStr, assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          if (res.data.data.length === 0) {
            this.$message.error('没有查询到对应的证书，请检查输入的证书号')
          } else {
            localStorage.setItem('resultData', JSON.stringify(res.data))
            this.$router.push({
              name: 'QueryResult'
            })
          }
        }
      })
    },
    keyDown (e) {
      //
      if (e.keyCode === 13) {
        this.getPersonCertificatr()
      }
    }
  },
  mounted () {
    // 绑定事件
    window.addEventListener('keydown', this.keyDown)
  },
  created () {
    // this.getQueryAllProject()
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDown, false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .news {
    /* width: 100%;
    height:100vh;
    overflow: auto; */
    background-color: #fff;
    position: relative;
  }
  .set-height{
    height: 648px;
    background: #f3f3f3;
  }
  @media screen and (max-height: 700px) {
    .set-height {
        height: 500px;
    }
}
  .news-content {
    width: 1100px;
    padding: 20px 50px 150px 50px;
    background: #f3f3f3;
    border-radius: 10px;
    margin-top: 20px;
  }
  .layout-center{
    overflow: hidden;
  }
  .layout-left{
    width: 110px;
    float: left;
    margin-right: 40px;
  }
  .certificate-nav{
    float: left;
    width: 950px;
  }
  .person-text-title{
    padding: 30px 0px;
    text-align: center
  }
  .person-text-title span{
    background: url(../../../static/images/ge-ren.png)0px center no-repeat;
    background-size: 20px 20px;
    padding: 10px 0px 10px 25px;
    font-size: 16px;
  }
  .news-content .clum {
    overflow: hidden;
    padding: 20px 0px;
  }

  .news-content .clum .icon {
    display: inline-block;
    font-size: 20px;
    background-position: 0px center;
    background-repeat: no-repeat;
    font-weight: 500;
    background-size: 5px 20px;
    background-image: url(../../../static/images/nwe-shuxian.png);
    padding-left: 14px;
    font-style: normal;
    color: #999;
  }

  .news-content .clum span {
    float: right;
    font-size: 16px;
    color: #888;
    line-height: 30px;
    cursor: pointer;
  }
  .person-bar{
    width: 100px;
  }
  .check-nav{
    padding-top:10px;
    width: 400px;
    margin: 0px auto;
  }
  .check-nav .submit-btn{
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .check-nav .el-input{
    margin-bottom: 20px;
  }
  .check-nav .submit-btn .el-button{
    background: #cc0000;
    color: #fff;
    border-color: #cc0000;
    padding: 10px 20px;
  }
  .person-bar span{
    font-size: 14px;
    color:#fff;
    background: #cc0000;
    border-radius: 5px;
    width: 94px;
    padding: 5px 0px;
    display: block;
    text-align: center
  }
  .text {
    border-radius: 5px;
    background: #fff;
    margin-top: 30px;
    padding:15px 10px;
    border-bottom: 0px;
  }
  .text p {
    font-size: 14px;
    color:#888;
    padding: 15px;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .seach{
    width: 100%;
    margin-bottom: 5px;
  }
  .seach .el-input{
    width: 300px;
  }
  .el-button{
    background: #cc0000;
    color: #fff;
  }
  .code_img{
    text-align: center;
    margin-top: 20px;
  }
  .code_img img{
    width: 160px;
    height: 160px;
  }
  .code_img span{
    display: block;
    text-align: center;
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }
  /* .fixd {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/pages/PersonalCertificate.vue